export default __webpack_public_path__ + "static/media/ceo33.cfadeb1c.png";